import { useState } from "react";

import {
  makeGetApiCall,
  makePostApiCall,
  makePutApiCall,
} from "../../../../shared/makeApiCall";
import { useToast } from "../../../../contexts/ToastContext";

export function UserDetailsViewModel(logout, userId) {
  const { showSuccess, showError } = useToast();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({});
  const [tenants, setTenants] = useState([]);


  const getUser = async function () {
    setLoading(true);
    const callResult = await makePostApiCall(`admin/users/${userId}`, {});
    if (callResult.success) {
      setUser(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showError(callResult.data?.message || "Unable to load the user.");
    }
    setLoading(false);
  };

  const createUser = async function (values) {
    const callResult = await makePostApiCall(`admin/createUser`, values);

    if (callResult.success) {
      showSuccess(
        callResult.data.message || "Action completed"
      );
      
      window.location = "/users/" + callResult.data.id;
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showError(callResult.data?.message || "Unable to create the user.");
    }
  };

  const updateUser = async function (values) {
    const callResult = await makePutApiCall(`admin/users/${userId}`, values);

    if (callResult.success) {
      showSuccess(
        callResult.data.message || "Action completed"
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showError(callResult.data?.message || "Unable to update the user.");
    }
  };

  const changeUserPasswordAdmin = async function (targetUserId, payload) {
    // targetUserId: id of the user whose password will be changed
    // payload expected: { password, password_confirmation }

    setLoading(true);
    const callResult = await makePostApiCall(
      `/admin/users/reset-password/${targetUserId}`,
      payload
    );
    setLoading(false);
    if (callResult.success) {
      showSuccess(
        callResult.data.message || "Action completed"
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showError(callResult.data?.message || "Unable to reset the password.");
    }
  };

  const getTenantsForDropdown = async function () {
    const callResult = await makeGetApiCall(`admin/tenants/dropdown`);

    if (callResult.success) {
      setTenants(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showError(callResult.data?.message || "Unable to load tenants.");
    }
  };


  return {
    createUser,
    updateUser,
    changeUserPasswordAdmin,
    getUser,
    user,
    loading,
    tenants,
    getTenantsForDropdown,
  };
}
